import { Tab, TabList, Tabs } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useOrgProfileMenuItems } from "./useOrgProfileMenuItems";

export const OrgProfileTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = useOrgProfileMenuItems();

  const currentSection = location.pathname.split("/").pop() || "information";
  const tabIndex = Math.max(
    menuItems.findIndex((item) => item.section === currentSection),
    0,
  );

  return (
    <Tabs index={tabIndex} onChange={(index) => navigate(menuItems[index].to)} colorScheme="teal">
      <TabList overflowX="auto" overflowY="hidden">
        {menuItems.map((item) => (
          <Tab key={item.section} whiteSpace="nowrap">
            {item.label}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};
